export default "__VITE_ASSET__efbf253b__"